import React from 'react'
import ReactTooltip from 'react-tooltip'
import {findIt, getDhcNo, roundFloat} from './Util'
import {
  ucp1_result,
  adrb2_result,
  adrb3_result,
  dietInit,
  gpx1_result,
  sod2_result,
  mmp1_result,
  actn3_result,
} from './dietSkinSportsUtil'
import Swipe from "./Swipe"
import {Link} from "react-router-dom";
import request from "superagent";
import {URL_GET_NUTRIENTS} from "../constants/Url";
import {SHINAGAWA_BFF_API_KEY} from "../constants/EnvItems";

export default class DetailSkinDietSports extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      detail: props.detail,
      gender: props.gender,
      dietInitial: null,
      dietNumber: null,
      skinNumber: null,
      dietNocall: null,
      skinNocall: null,
      sportsType: null,
      sportsNocall: null,
      subtypes: null,
      nutrients: null,
    }
  }

  printDetail() {

    var domClone = document.getElementById("c-modal__content").cloneNode(true);
    var printSection = document.getElementById("r-wrapper");
    var noPrint = document.getElementById("l-wrapper");
    printSection.innerHTML = "";
    printSection.appendChild(domClone);

    noPrint.style.display = "none";
    for(var i=0; i<document.getElementById("c-modal__content").getElementsByTagName('canvas').length; i++){
      var canvasf = document.getElementById("c-modal__content").getElementsByTagName('canvas')[i];
      var canvast = printSection.getElementsByTagName('canvas')[i];
      var image = canvasf.getContext('2d').getImageData(0, 0, canvasf.width, canvasf.height);
      canvast.getContext('2d').putImageData(image, 0, 0);
    }



    window.print();

    printSection.innerHTML = "";
    noPrint.style.display = "block";
    return false;
  }

  componentWillMount() {
    const r = this.state.detail;
    const u = r.unit;

    // 521は肌タイプ, 550は筋肉タイプのunit_id
    if (u.id === 521) {
      this.skinGene();
    } else if (u.id === 550) {
      this.sportsGene();
    } else {
      this.dietGene();
    }
  }

  fetchNutrients(subtypes) {
    // TODO 複数アフィリエイト対応する際には気をつけて
    let dhc_no = getDhcNo(subtypes);
    request
        .get(URL_GET_NUTRIENTS(this.state.customer_id, dhc_no))
        .set('Accept', 'application/json')
        .set('Content-Type', 'application/json')
        .set('x-api-key', SHINAGAWA_BFF_API_KEY)
        .end((err, res) => {
          if (err) {
            return;
          }
          this.setState( {nutrients: res.body})
        });
  }

  dietGene() {
    const r = this.state.detail;
    const u = r.unit;
    const genes = r.detail_genes;
    const GH040251 = u.descriptions[0].gene_master.ghnumber
    const GH050239 = u.descriptions[1].gene_master.ghnumber
    const GH080240 = u.descriptions[2].gene_master.ghnumber

    const dietNocall = r.split_level_name[1]

    const ucp1 = findIt(genes, 'ghnumber', GH040251)[0].value;
    const adrb2 = findIt(genes, 'ghnumber', GH050239)[0].value;
    const adrb3 = findIt(genes, 'ghnumber', GH080240)[0].value;

    let dietNumber = (adrb3_result(adrb3).toString() + ucp1_result(ucp1).toString() + adrb2_result(adrb2).toString())
    let gender = this.state.gender
    let border = gender == "male" ? 19 : 7
    let subtypes = r.subtype.diet.filter(subtype => subtype.gender == gender);
    let dietInitial = dietInit(border, ucp1, adrb2, adrb3).toString()

    this.setState({
      dietInitial: dietInitial,
      dietNumber: dietNumber,
      dietNocall: dietNocall,
      subtypes: subtypes
    });
    if (r.split_level_name[1] !== '判定不能') {
      this.fetchNutrients(subtypes);
    }
  }

  skinGene() {
    const r = this.state.detail;
    const u = r.unit;
    const genes = r.detail_genes;
    const GH030247 = u.descriptions[0].gene_master.ghnumber
    const GH060310 = u.descriptions[1].gene_master.ghnumber
    const GH110277 = u.descriptions[2].gene_master.ghnumber

    const gpx1 = findIt(genes, 'ghnumber', GH030247)[0].value;
    const sod2 = findIt(genes, 'ghnumber', GH060310)[0].value;
    const mmp1 = findIt(genes, 'ghnumber', GH110277)[0].value;

    const skinNocall = r.split_level_name[1]

    let skinNumber = (mmp1_result(mmp1).toString() + sod2_result(sod2).toString() + gpx1_result(gpx1).toString())

    this.setState({
      skinNumber: skinNumber,
      skinNocall: skinNocall
    });
  }

  sportsGene() {
    const r = this.state.detail;
    const u = r.unit;
    const genes = r.detail_genes;
    const GH110255 = u.descriptions[0].gene_master.ghnumber

    const actn3 = findIt(genes, 'ghnumber', GH110255)[0].value;

    const sportsNocall = r.split_level_name[1]

    let sportsType = (actn3_result(actn3))

    this.setState({
      sportsType: sportsType,
      sportsNocall: sportsNocall
    });
  }

  render() {

    const { dietNumber, dietInitial, skinNumber, dietNocall, skinNocall, sportsType, sportsNocall } = this.state

    const r = this.state.detail;
    const u = r.unit;
    const dg = r.detail_genes;
    const unitName = u.name;
    const unitSummary = u.summary.split('<br>');
    const unitExplanation = u.explanation.split('<br>');
    const unitPrevention = u.prevention.split('<br>');
    const levelName = r.split_level_name[0] + r.split_level_name[1] + r.split_level_name[2];
    const references = u.references;

    const genes = [];
    u.descriptions.map(d => {

      const cellSelect = findIt(dg, 'ghnumber', d.gene_master.ghnumber)[0].value;

      const gene = new Map();
      gene.set('gh_number', d.gene_master.ghnumber);
      gene.set('gene_name', d.gene_name);
      gene.set('explanation', d.explanation);
      gene.set('evidence_rank', d.evidence_rank);
      gene.set('type_1', d.gene_master.alleles[0].value);
      gene.set('type_1_freq', roundFloat((d.gene_master.alleles[0].population_frequency * 100), 2));
      gene.set('type_1_style', 'nomcell' + (cellSelect === d.gene_master.alleles[0].value ? ' cell_select' : ''));
      gene.set('type_2', d.gene_master.alleles[1].value);
      gene.set('type_2_freq', roundFloat((d.gene_master.alleles[1].population_frequency * 100), 2));
      gene.set('type_2_style', 'nomcell' + (cellSelect === d.gene_master.alleles[1].value ? ' cell_select' : ''));
      gene.set('type_3', d.gene_master.alleles[2].value);
      gene.set('type_3_freq', roundFloat((d.gene_master.alleles[2].population_frequency * 100), 2));
      gene.set('type_3_style', 'nomcell' + (cellSelect === d.gene_master.alleles[2].value ? ' cell_select' : ''));
      genes.push(gene);
      return null;
    });

    let loopKey = 0;

    const recipeUrl = 'https://s3-ap-northeast-1.amazonaws.com/gh-static-contents/reports/recipe'


    let recommend_meal = null;
    if (this.props.affiliate_agreed && this.state.nutrients) {
      let subtypes = this.state.subtypes;
      recommend_meal =
          <div className="sect">
            <h3>おすすめの成分</h3>
            <div className="inddata">
              <table className="noseparate nutrition_tbl">
                <thead>
                <tr>
                  <th scope="col">成分</th>
                  <th scope="col">説明</th>
                </tr>
                </thead>
                <tbody>
                {this.state.nutrients.map(n => {
                  return (
                      <tr key={Math.random()}>
                        <td className="nutrition_name">{n.Item.name}</td>
                        <td className="nutrition_discription">{n.Item.description}</td>
                      </tr>);
                })}
                </tbody>
              </table>
            </div>
            <Link to='/recommendation'  onClick={() => { (this.props.openAffiliateResult(this.state.detail, subtypes)); }} className="nut_bn"><img src="image/nutrition/bn_splad.png" alt="あなたにおすすめの商品" /></Link>
          </div>
    }

    return (

      <div className="wrap">

        <div className="detail_header">
          <div className="wrap cfx">
            <h2 className="header_title">{unitName}</h2>
              <div className="header_btnwrap">
                {<span className="btn detail_print" onClick={this.printDetail.bind()}>印刷する</span>}
              </div>
          </div>
        </div>

        <div className="detailwrap">
          <div className="sect">
            <h3>あなたの判定結果</h3>
            <p className="detail_risk_result">{levelName}</p>
          </div>

            { (u.id === 521 && skinNocall !== "判定不能") ? //skinの結果が正常
              <div className="btrepo_box">
                <p className="center">検査結果は以下からより詳しくご覧いただけます。</p>
                <div className="top_b_repo">
                  <div className="btrepo">
                    <img src={require("../images/books/skin_repo.svg") } />
                    <Swipe btKitName="肌タイプ"
                      skinNumber = {skinNumber}
                    />
                  </div>
                  <div className="btrepo"><img src={require("../images/books/skin_recipe.svg")} /><br/><a href={recipeUrl + '/recipe_sk.pdf'} className="btn_open" target="_blank">肌タイプ<br/>レシピブック</a></div>
                  </div>
               </div>
            : (u.id === 521) ? //skinがnocallの場合
               <div></div>
            : (u.id === 550 && sportsNocall !== "判定不能") ? //sportsの結果が正常
              <div className="btrepo_box">
                <p className="center">検査結果は以下からより詳しくご覧いただけます。</p>
                <div className="top_b_repo">
                  <div className="btrepo">
                    <img src={require("../images/books/sp_repo.svg") } />
                    <Swipe btKitName="筋肉タイプ"
                      sportsType = {sportsType}
                    />
                  </div>
                  <div className="btrepo"><img src={require("../images/books/sp_recipe.svg")} /><br /><a href={recipeUrl + '/recipe_sp.pdf'} className="btn_open" target="_blank">筋肉タイプ<br/>レシピブック</a></div>
                  </div>
              </div>
            : (u.id === 550) ? //sportsがnocallの場合
              <div></div>
            : (dietNocall !== "判定不能") ? 　 //dietの結果が正常
              <div className="btrepo_box">
                <p className="center">検査結果は以下からより詳しくご覧いただけます。</p>
                  <div className="top_b_repo">
                    <div className="btrepo">
                      <img src={require("../images/books/diet_repo.svg") } />
                      <Swipe btKitName="肥満タイプ"
                        dietNumber = {dietNumber}
                        dietInitial = {dietInitial}
                      />
                    </div>
                    <div className="btrepo"><img src={require("../images/books/diet_recipe.svg")} /><br /><a href={recipeUrl + '/recipe_di.pdf'} className="btn_open" target="_blank">肥満タイプ<br />レシピブック</a></div>
                    </div>
              </div>
             :               //dietがnocallの場合
              <div></div>
            }

          <div className="sect">
            <h3>結果説明</h3>
            <div className="descrpt">
              <p>
                {unitExplanation.length > 0 && unitExplanation.map(s => {
                  return (<span key={"unitExplanation" + loopKey++}>{s}<br/></span>)
                })}
              </p>
            </div>
          </div>

          <div className="sect">
            <h3>項目概要</h3>
            <div className="descrpt">
              <p>
                {unitSummary.length > 0 && unitSummary.map(s => {
                  return (<span key={"unitSummary" + loopKey++}>{s}<br/></span>)
                })}
              </p>
              <p className="center"><img src={`https://s3-ap-northeast-1.amazonaws.com/genesis2/images/detail/unit_id_${u.id}.png`} alt=""/></p>
            </div>
          </div>

          <div className="sect">
            <h3>ジーンライフからの提案</h3>
            <div className="descrpt">
              <p>
                {unitPrevention.length > 0 && unitPrevention.map(s => {
                  return (<span key={"unitPrevention" + loopKey++}>{s}<br/></span>)
                })}
              </p>
            </div>
          </div>


          <div className="sect">
            <h3>遺伝子多型の頻度情報</h3>
            <div className="inddata">
              <table>
                <thead>
                <tr>
                  <th scope="col">多型部位</th>
                  <th scope="col">関連遺伝子</th>
                  <th scope="col">1st（頻度）</th>
                  <th scope="col">2nd（頻度）</th>
                  <th scope="col">3rd（頻度）</th>
                </tr>
                </thead>
                <tbody>
                {genes.map(f => {
                    return (
                      <tr key={Math.random()}>
                        <td className="inddata_part" data-label="多型部位">{f.get("gh_number")}</td>
                        <td className="nomcell" data-label="関連遺伝子">{f.get("gene_name")}</td>
                        <td className={f.get("type_1_style")} data-label="1st（頻度）">{f.get("type_1")}({f.get("type_1_freq")}%)</td>
                        <td className={f.get("type_2_style")} data-label="2nd（頻度）">{f.get("type_2")}({f.get("type_2_freq")}%)</td>
                        <td className={f.get("type_3_style")} data-label="3rd（頻度）">{f.get("type_3")}({f.get("type_3_freq")}%)</td>
                      </tr>);
                  }
                )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="sect">
            <h3>解析遺伝子情報</h3>
            <div className="inddata">
              <table>
                <thead>
                <tr>
                  <th scope="col">多型部位</th>
                  <th scope="col">関連遺伝子</th>
                  <th scope="col">説明</th>
                  <th scope="col">信頼性<span data-tip data-for='evidence_rank'> (※) </span>
                    <ReactTooltip id='evidence_rank' type='dark' effect='solid' place="bottom">
                      <div className="evidence_rank_text">
                        <h3>信頼性について</h3>
                        <ul>
                          <li>1. P値の評価（5 x 10<sup>-8</sup>以下であるか）</li>
                          <li>2. 人種の評価（アジア人、日本人を対象にしているか）</li>
                          <li>3. 母集団の大きさの評価（1000人以上であるか）</li>
                          <li>上記3点の総合評価を基に信頼性が高い順に3、2、1と定義しております。</li>
                        </ul>
                      </div>
                    </ReactTooltip>
                  </th>
                </tr>
                </thead>
                <tbody>
                {genes.map(f => {
                    return (
                      <tr key={Math.random()}>
                        <td className="inddata_part" data-label="多型部位">{f.get("gh_number")}</td>
                        <td className="nomcell" data-label="関連遺伝子">{f.get("gene_name")}</td>
                        <td className="inddata_descript" data-label="説明"><p>{f.get("explanation")}</p></td>
                        <td className="nomcell" data-label="信頼性(※)">{f.get("evidence_rank")}</td>
                      </tr>);
                  }
                )}
                </tbody>
              </table>
              <div className="sp_only">
                <h4>※信頼性について</h4>
                <ul>
                  <li>1. P値の評価（5 x 10<sup>-8</sup>以下であるか）</li>
                  <li>2. 人種の評価（アジア人、日本人を対象にしているか）</li>
                  <li>3. 母集団の大きさの評価（1000人以上であるか）</li>
                  <li>上記3点の総合評価を基に信頼性が高い順に3、2、1と定義しております。</li>
                </ul>
              </div>
            </div>
          </div>
          {recommend_meal}
          <div className="sect">
            <h3>参考文献</h3>
            <div className="descrpt">
              <ul>
                {references.map(ref => {
                  return <li key={ref.title}>{ref.title}</li>
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DetailSkinDietSports.js